import { useMemo } from 'react';

/**
 * Provides a random ID based on Math.random and the current time.
 * This hook is useful is you need a random ID for a DOM element.
 * A specific use case is for ARIA attributes.
 */
export function useRandomId(): string {
  return useMemo(() => {
    return Date.now().toString(36) + Math.random().toString(36).slice(2);
  }, []);
}
